import PropTypes from 'prop-types';

function TaskPipettingProfileWrapper({children}) {
  return <div className="task-pipetting-param">{children}</div>;
}

TaskPipettingProfileWrapper.propTypes = {
  children: PropTypes.any,
};

TaskPipettingProfileWrapper.defaultProps = {
  children: null,
};

export default TaskPipettingProfileWrapper;
